var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.viewshedComb,
          expression: "viewshedComb"
        }
      ]
    },
    [
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-point media-hidden" }),
        _c(
          "label",
          {
            staticClass: "sm-function-module-sub-section-setting media-hidden"
          },
          [_vm._v("观察者信息")]
        ),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("经度(°)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.viewlongitude,
                  expression: "viewlongitude"
                }
              ],
              staticClass: "sm-input-right",
              attrs: { type: "text", id: "viewshed-observation-place-x" },
              domProps: { value: _vm.viewlongitude },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.viewlongitude = $event.target.value
                }
              }
            })
          ]),
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              {
                staticClass: "sm-function-module-sub-section-caption",
                staticStyle: { "margin-left": "20px" }
              },
              [_vm._v("纬度(°)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.viewlatitude,
                  expression: "viewlatitude"
                }
              ],
              staticClass: "sm-input-right",
              attrs: { type: "text", id: "viewshed-observation-place-y" },
              domProps: { value: _vm.viewlatitude },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.viewlatitude = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", [
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("高程(m)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.viewheight,
                  expression: "viewheight"
                }
              ],
              staticClass: "sm-input-right",
              attrs: { type: "text", id: "viewshed-observation-place-z" },
              domProps: { value: _vm.viewheight },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.viewheight = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-point media-hidden" }),
        _c(
          "label",
          {
            staticClass: "sm-function-module-sub-section-setting media-hidden"
          },
          [_vm._v("参数设置")]
        ),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("附加高度(m)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.addheight,
                  expression: "addheight"
                }
              ],
              staticClass: "sm-input sm-input-long",
              attrs: { type: "number", id: "addheight", step: "0.1", min: "0" },
              domProps: { value: _vm.addheight },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.addheight = $event.target.value
                }
              }
            })
          ]),
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              {
                staticClass: "sm-function-module-sub-section-caption",
                staticStyle: { "margin-left": "20px" }
              },
              [_vm._v("方向角(°)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.direction,
                  expression: "direction"
                }
              ],
              staticClass: "sm-input sm-input-long",
              attrs: {
                type: "number",
                id: "direction",
                min: "0",
                max: "360",
                step: "1.0",
                title: "方向角"
              },
              domProps: { value: _vm.direction },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.direction = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "sm-function-module-sub-section" }, [
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("可视距离(m)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.distance,
                  expression: "distance"
                }
              ],
              staticClass: "sm-input sm-input-long",
              attrs: {
                type: "number",
                id: "distance",
                min: "1",
                step: "1",
                title: "可视距离"
              },
              domProps: { value: _vm.distance },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.distance = $event.target.value
                }
              }
            })
          ]),
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              {
                staticClass: "sm-function-module-sub-section-caption",
                staticStyle: { "margin-left": "20px" }
              },
              [_vm._v("俯仰角(°)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.pitch,
                  expression: "pitch"
                }
              ],
              staticClass: "sm-input sm-input-long",
              attrs: {
                type: "number",
                id: "pitch",
                min: "-90",
                max: "90",
                step: "1.0",
                title: "俯仰角"
              },
              domProps: { value: _vm.pitch },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.pitch = $event.target.value
                }
              }
            })
          ])
        ]),
        _c("div", [
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("水平视角(°)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.horizontalFov,
                  expression: "horizontalFov"
                }
              ],
              staticClass: "sm-input sm-input-long",
              attrs: {
                type: "number",
                id: "horizontalFov",
                min: "1",
                max: "120",
                step: "1.0",
                title: "水平视角"
              },
              domProps: { value: _vm.horizontalFov },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.horizontalFov = $event.target.value
                }
              }
            })
          ]),
          _c("div", { staticClass: "sm-half" }, [
            _c(
              "label",
              {
                staticClass: "sm-function-module-sub-section-caption",
                staticStyle: { "margin-left": "20px" }
              },
              [_vm._v("垂直视角(°)")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.verticalFov,
                  expression: "verticalFov"
                }
              ],
              staticClass: "sm-input sm-input-long",
              attrs: {
                type: "number",
                id: "verticalFov",
                min: "1",
                step: "1.0",
                title: "垂直视角"
              },
              domProps: { value: _vm.verticalFov },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.verticalFov = $event.target.value
                }
              }
            })
          ])
        ])
      ]),
      _c("div", { staticClass: "sm-function-module-content" }, [
        _c("div", { staticClass: "sm-point" }),
        _c("label", { staticClass: "sm-function-module-sub-section-setting" }, [
          _vm._v("颜色设置")
        ]),
        _c(
          "div",
          [
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("提示线颜色")]
            ),
            _c("ColorPicker", {
              staticClass: "sm-colorpicker",
              attrs: { alpha: "" },
              model: {
                value: _vm.hintLineColor,
                callback: function($$v) {
                  _vm.hintLineColor = $$v
                },
                expression: "hintLineColor"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("input", { attrs: { type: "checkbox", checked: "" } }),
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("可见区域")]
            ),
            _c("ColorPicker", {
              staticClass: "sm-colorpicker",
              attrs: { alpha: "" },
              model: {
                value: _vm.visibleAreaColor,
                callback: function($$v) {
                  _vm.visibleAreaColor = $$v
                },
                expression: "visibleAreaColor"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("input", { attrs: { type: "checkbox", checked: "" } }),
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("不可见区域")]
            ),
            _c("ColorPicker", {
              staticClass: "sm-colorpicker",
              attrs: { alpha: "" },
              model: {
                value: _vm.hiddenAreaColor,
                callback: function($$v) {
                  _vm.hiddenAreaColor = $$v
                },
                expression: "hiddenAreaColor"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.visibleBody,
                  expression: "visibleBody"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.visibleBody)
                  ? _vm._i(_vm.visibleBody, null) > -1
                  : _vm.visibleBody
              },
              on: {
                change: function($event) {
                  var $$a = _vm.visibleBody,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.visibleBody = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.visibleBody = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.visibleBody = $$c
                  }
                }
              }
            }),
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("显示可视体")]
            ),
            _c("ColorPicker", {
              staticClass: "sm-colorpicker",
              attrs: { alpha: "" },
              model: {
                value: _vm.visibleBodyColor,
                callback: function($$v) {
                  _vm.visibleBodyColor = $$v
                },
                expression: "visibleBodyColor"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.invisibleBody,
                  expression: "invisibleBody"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.invisibleBody)
                  ? _vm._i(_vm.invisibleBody, null) > -1
                  : _vm.invisibleBody
              },
              on: {
                change: function($event) {
                  var $$a = _vm.invisibleBody,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.invisibleBody = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.invisibleBody = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.invisibleBody = $$c
                  }
                }
              }
            }),
            _c(
              "label",
              { staticClass: "sm-function-module-sub-section-caption" },
              [_vm._v("显示不可视体")]
            ),
            _c("ColorPicker", {
              staticClass: "sm-colorpicker",
              attrs: { alpha: "" },
              model: {
                value: _vm.invisibleBodyColor,
                callback: function($$v) {
                  _vm.invisibleBodyColor = $$v
                },
                expression: "invisibleBodyColor"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "boxchild" }, [
          _c(
            "button",
            {
              staticClass: "tbtn tbn1",
              attrs: { type: "button" },
              on: { click: _vm.chooseView }
            },
            [_vm._v(" 分析 ")]
          ),
          _c(
            "button",
            {
              staticClass: "tbtn",
              attrs: { type: "button" },
              on: { click: _vm.clear }
            },
            [_vm._v("清除")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }